import React, { useCallback, useEffect, useState } from "react";
import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import Header from "../../Components/Header";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import useSelect from "../../Hooks/useSelect";
import useToggle from "../../Hooks/useToggle";
import { useGetReviewsQuery, useUpdateReviewMutation } from "../../Redux/Apis/Review";
import { dateFormatter } from "../../Utils";
import CustomTable from "./../../Components/CustomTable";
import ProfileDisplay from "./../../Components/ProfileDisplay";
import "./style.css";
import useSearch from "../../Hooks/useSearch";
import usePagination from "../../Hooks/usePagination";

const sortValues = [
    {
        text: "Name",
        value: "fullName",
    },
    {
        text: "Email",
        value: "email",
    }
];

const perPageValues = [
    {
        text: "8",
        value: 8,
    },
    {
        text: "15",
        value: 15,
    },
    {
        text: "30",
        value: 30,
    }
];

const maleHeaders = [
    {
        key: "id",
        title: "S.No",
    },
    {
        key: "title",
        title: "From",
    },
    {
        key: "title",
        title: "To",
    },
    {
        key: "subtitle",
        title: "Review",
    },
    {
        key: "subtitle",
        title: "Rating",
    },
    {
        key: "createdAt",
        title: "Created Date",
    },
    {
        key: "actions",
        title: "",
    },
];

const Reviews = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
    const [inputValue, setInputValue] = useState('');
    const [selectedData, setSelectedData] = useState();

    const [isFilterOpen, setIsFilterOpen, toggleFilter] = useToggle()

    const [sortBy, setSortBy] = useState(sortValues[0].value);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");

    const [search, debouncedSearch, onSearch] = useSearch()
    const { page, perPage, onNext, onPrevious } = usePagination()
    const { data, isLoading, refetch } = useGetReviewsQuery({
        page,
        rowsPerPage: perPage,
        search: debouncedSearch,
        sortBy,
        from,
        to,
        status: "pending"
    });
    const [updateReview, { data: updatedData, isSuccess: isUpdated, isLoading: isUpdating }] = useUpdateReviewMutation();

    const { isAllSelected, totalSelected, onSelectAll, onSelectRow, isExists } = useSelect(data?.data)

    const [approval, setApproval, toggleApproval] = useToggle()
    const [rejection, setRejection, toggleRejection] = useToggle()
    const [successModal, _, toggleSuccessModal] = useToggle()

    useEffect(() => {
        if (isUpdated) {
            refetch()
            setSelectedData()
            setApproval(false)
            setRejection(false)
            toggleSuccessModal()
        }
    }, [isUpdated])

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    useEffect(() => {
        document.title = 'The Turn At | Reviews';
    }, []);

    const onUpdate = useCallback(() => {

        let payload = {
            _id: selectedData?._id
        }

        if (approval) {
            payload = {
                ...payload,
                status: "approved"
            }
        } else if (rejection) {
            payload = {
                ...payload,
                status: "rejected"
            }
        }

        updateReview(payload)

    }, [approval, rejection])

    return (
        <>
            <DashboardLayout>
                <div className="container-fluid">
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="dashCard">
                                <Header
                                    title="Reviews"
                                    length={totalSelected}
                                    search={search}
                                    onSearch={onSearch}
                                    nofilters
                                />
                                <div className="row mb-3">
                                    {
                                        isLoading ? <Loader /> :
                                            <div className="col-12">
                                                <CustomTable
                                                    headers={maleHeaders}
                                                    isFilterOpen={isFilterOpen}
                                                    dateFilter={false}
                                                    filterSort={false}
                                                    perPage={true}
                                                    filterSortValues={sortValues}
                                                    perPageValues={perPageValues}
                                                    filterSortValue={sortBy}
                                                    setFilterSortValue={setSortBy}
                                                    filterFrom={from}
                                                    setFilterFrom={setFrom}
                                                    filterTo={to}
                                                    setFilterTo={setTo}
                                                    itemsPerPage={itemsPerPage}
                                                    setItemsPerPage={setItemsPerPage}
                                                    length={data?.data?.length}
                                                    isAllSelected={isAllSelected}
                                                    onSelectAll={onSelectAll}
                                                    page={page}
                                                    rowsPerPage={perPage}
                                                    onNext={onNext}
                                                    onPrevious={onPrevious}
                                                    total={data?.total}
                                                >
                                                    <tbody>
                                                        {data?.data?.map((item, index) => (
                                                            <tr key={item._id}>
                                                                {/* <td><input type="checkbox" value={item._id} checked={isExists(item._id)} onClick={() => onSelectRow(item?._id)} /></td> */}
                                                                <td>{(index + 1) + ((currentPage - 1) * itemsPerPage)}</td>
                                                                <td>
                                                                    <ProfileDisplay
                                                                        name={`${item?.review_by?.first_name} ${item?.review_by?.last_name}`}
                                                                        email={item?.review_by?.email}
                                                                        image={item?.review_by?.profile_photo}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <ProfileDisplay
                                                                        name={`${item?.review_to?.first_name} ${item?.review_to?.last_name}`}
                                                                        email={item?.review_to?.email}
                                                                        image={item?.review_to?.profile_photo}
                                                                    />
                                                                </td>
                                                                <td>{item.feedback}</td>
                                                                <td>{item.rating}</td>
                                                                <td>{dateFormatter(item?.createdAt)}</td>
                                                                <td className="d-flex justify-content-center align-items-center">
                                                                    <CustomButton variant="primaryButton" text="Approve" className="mx-1" onClick={() => { setSelectedData(item), toggleApproval() }} />
                                                                    <CustomButton variant="dangerButton" text="Reject" className="mx-1" onClick={() => { setSelectedData(item), toggleRejection() }} />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </CustomTable>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <CustomModal loading={isUpdating} show={approval || rejection} close={() => { setApproval(false), setRejection(false) }} action={onUpdate} heading={`Are you sure you want to ${approval ? "approve" : "reject"} this review?`} />
                    <CustomModal show={successModal} close={toggleSuccessModal} success heading={updatedData?.message} />
                </div >
            </DashboardLayout >
        </>
    );
};

export default Reviews